var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewStarSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5251 4.0202C12.8155 3.43186 13.6545 3.43186 13.9449 4.0202L16.4538 9.10287L22.0654 9.92308C22.7145 10.018 22.9732 10.8158 22.5032 11.2735L18.4434 15.2279L19.4013 20.8133C19.5123 21.46 18.8334 21.9532 18.2526 21.6478L13.235 19.0091L8.21748 21.6478C7.63669 21.9532 6.9578 21.46 7.06873 20.8133L8.02669 15.2279L3.96681 11.2735C3.49689 10.8158 3.75559 10.018 4.40469 9.92308L10.0163 9.10287L12.5251 4.0202Z",
    fill: "#DE9C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStarSvg);
export default __webpack_public_path__ + "static/media/reviewStarSvg.24b95173ef142e6f400959bfae69b77b.svg";
export { ForwardRef as ReactComponent };